import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onClick"];
import DrawerTrigger from "src/shared/v-components/ui/drawer/DrawerTrigger.vue";
import ImagePreviewDialog from "./ImagePreviewDialog.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImagePreviewDialogTrigger',
    props: {
        src: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DrawerTrigger, null, {
                trigger: _withCtx(({ openDrawer }) => [
                    _createElementVNode("i", {
                        class: "far fa-search-plus",
                        onClick: openDrawer
                    }, null, 8 /* PROPS */, _hoisted_1)
                ]),
                drawer: _withCtx(({ drawerClosed }) => [
                    _createVNode(ImagePreviewDialog, {
                        src: props.src,
                        onClosed: drawerClosed
                    }, null, 8 /* PROPS */, ["src", "onClosed"])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
